declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

/**
 * Tracks a custom event in Google Analytics 4
 * @param eventName The name of the event (e.g., 'click_direction', 'generate_lead')
 * @param params Additional parameters (category, label, value, etc.)
 */
export const trackEvent = (
  eventName: string, 
  params?: { 
    event_category?: string; 
    event_label?: string; 
    value?: number;
    [key: string]: any 
  }
) => {
  // Check if GA is initialized
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  } else {
    // Fallback log for development or if analytics is blocked
    console.debug(`[Analytics] Event: ${eventName}`, params);
  }
};